module.exports = "<footer>\n\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/layout/footer.component.html
// module id = ../../../../../src/app/layout/footer.component.html
// module chunks = 0